var _sodipodiNamedview, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleTasks2021(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8849",
    inkscapeVersion: "1.1 (c68e22c387, 2021-05-23)",
    sodipodiDocname: "google tasks.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "527.1px",
    height: "500px",
    viewBox: "0 0 527.1 500",
    enableBackground: "new 0 0 527.1 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    bordercolor: "#eeeeee",
    borderopacity: 1,
    id: "namedview8851",
    "inkscapeBbox-nodes": "true",
    "inkscapeBbox-paths": "true",
    "inkscapeCurrent-layer": "layer1",
    inkscapeCx: 280.62992,
    inkscapeCy: 277.14384,
    "inkscapeDocument-units": "mm",
    "inkscapeObject-paths": "true",
    inkscapePagecheckerboard: 0,
    inkscapePageopacity: 0,
    inkscapePageshadow: 0,
    "inkscapeSnap-bbox": "true",
    "inkscapeSnap-bbox-edge-midpoints": "true",
    "inkscapeSnap-bbox-midpoints": "true",
    "inkscapeSnap-center": "true",
    "inkscapeSnap-global": "true",
    "inkscapeSnap-intersection-paths": "true",
    "inkscapeSnap-midpoints": "true",
    "inkscapeSnap-object-midpoints": "true",
    "inkscapeSnap-page": "true",
    "inkscapeSnap-smooth-nodes": "true",
    "inkscapeSnap-text-baseline": "true",
    "inkscapeWindow-height": 1009,
    "inkscapeWindow-maximized": 1,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": 760,
    inkscapeZoom: 1.4342733,
    pagecolor: "#505050",
    showgrid: "false",
    units: "px"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0066DA",
    points: "410.4,58.3 368.8,81.2 348.2,120.6 368.8,168.8 407.8,211 450,187.5 475.9,142.8 450,87.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FC",
    d: "M249.3,219.4l98.9-98.9c29.1,22.1,50.5,53.8,59.6,90.4L272.1,346.7c-12.2,12.2-32,12.2-44.2,0l-91.5-91.5 c-9.8-9.8-9.8-25.6,0-35.3l39-39c9.8-9.8,25.6-9.8,35.3,0L249.3,219.4z M519.8,63.6l-39.7-39.7c-9.7-9.7-25.6-9.7-35.3,0 l-34.4,34.4c27.5,23,49.9,51.8,65.5,84.5l43.9-43.9C529.6,89.2,529.6,73.3,519.8,63.6z M412.5,250c0,89.8-72.8,162.5-162.5,162.5 S87.5,339.8,87.5,250S160.2,87.5,250,87.5c36.9,0,70.9,12.3,98.2,33.1l62.2-62.2C367,21.9,311.1,0,250,0C111.9,0,0,111.9,0,250 s111.9,250,250,250s250-111.9,250-250c0-38.3-8.7-74.7-24.1-107.2L407.8,211C410.8,223.5,412.5,236.6,412.5,250z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTasks2021);
export default __webpack_public_path__ + "static/media/Google_Tasks_2021.80ce6c657ef3141b27b2d13479f9a1ae.svg";
export { ForwardRef as ReactComponent };